import aiEmailTemplateCRUDActions from '../actions/AIEmailTemplatesCRUDActions';
import {
  AIEmailTemplate,
  AIEmailTemplateStatus,
} from '../interfaces/aiEmailTemplates';
import { setBusy } from './common/commonReducers';

export type AIEmailTemplatesState = {
  busy: boolean;
  processed: boolean;
  aiEmailTemplate: AIEmailTemplate | null;
  error: string | null;
  processing: boolean;
  canceled: boolean;
};

const initialState: AIEmailTemplatesState = {
  busy: false, // Request state
  processing: false, // Pooling state
  processed: false, // Flag to show that we have got the right status
  canceled: false, // Manually canceled
  aiEmailTemplate: null,
  error: null,
};

export const PROCESSED_STATUSES: AIEmailTemplate['status'][] = [
  AIEmailTemplateStatus.scraped,
  AIEmailTemplateStatus.failed,
];

export function aiEmailTemplates(state = initialState, action) {
  switch (action.type) {
    case aiEmailTemplateCRUDActions.busyAction:
      return setBusy(state);
    case aiEmailTemplateCRUDActions.toggleProcessingAction:
      return {
        ...state,
        processing: action.payload.value,
      };
    case aiEmailTemplateCRUDActions.cancelAction:
      return {
        ...state,
        canceled: true,
        processing: false,
        error: action.payload.error,
      };
    case aiEmailTemplateCRUDActions.retrievedAction: {
      const processed =
        state.processed ||
        (!!action.entity.aiEmailTemplate &&
          PROCESSED_STATUSES.includes(action.entity.aiEmailTemplate?.status)) ||
        !!action.entity.error;
      const attrs: Partial<AIEmailTemplatesState> = {
        aiEmailTemplate: action.entity.aiEmailTemplate,
        busy: false,
        processed,
        processing: !processed,
      };

      if (action.entity.error) {
        attrs.error = action.entity.error;
      }
      return {
        ...state,
        ...attrs,
      };
    }
    case aiEmailTemplateCRUDActions.resetAction:
      return { ...initialState };
    default:
      return state;
  }
}
